import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Compass, Map, User, Award } from 'lucide-react';

const TABS = [
  { key: 'home', label: 'Home', icon: Home, path: '/dashboard' },
  { key: 'explore', label: 'Explore', icon: Compass, path: '/discovery' },
  { key: 'map', label: 'Map', icon: Map, path: '/discovery?view=map' },
  { key: 'badges', label: 'Badges', icon: Award, path: '/badges' },
  { key: 'profile', label: 'Profile', icon: User, path: '/profile' },
];

const isActiveTab = (tab, location) => {
  const { pathname, search } = location;
  if (tab.key === 'map') {
    return pathname.startsWith('/discovery') && search.includes('view=map');
  }
  if (tab.key === 'explore') {
    return pathname.startsWith('/discovery') && !search.includes('view=map');
  }
  if (tab.key === 'home') return pathname === '/dashboard';
  if (tab.key === 'badges') return pathname.startsWith('/badges');
  if (tab.key === 'profile') return pathname.startsWith('/profile') || pathname.startsWith('/settings');
  return false;
};

export const BottomTabNav = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-[1100] md:hidden bg-background/90 backdrop-blur-xl border-t border-border/50 [isolation:isolate]"
      style={{ paddingBottom: 'max(env(safe-area-inset-bottom), 8px)' }}
      data-testid="bottom-tab-nav"
      aria-label="Primary mobile navigation"
    >
      <ul className="flex items-stretch justify-around px-1 pt-1.5">
        {TABS.map((tab) => {
          const Icon = tab.icon;
          const active = isActiveTab(tab, location);
          return (
            <li key={tab.key} className="flex-1">
              <button
                type="button"
                onClick={() => navigate(tab.path)}
                aria-current={active ? 'page' : undefined}
                aria-label={tab.label}
                data-testid={`bottom-tab-${tab.key}`}
                className={`group flex w-full min-h-[56px] flex-col items-center justify-center gap-0.5 rounded-xl px-2 py-1 transition-all active:scale-95 ${
                  active ? 'text-primary' : 'text-muted-foreground hover:text-foreground'
                }`}
              >
                <span
                  className={`flex h-7 w-7 items-center justify-center transition-transform ${
                    active ? 'scale-110' : 'scale-100'
                  }`}
                >
                  <Icon className="h-5 w-5" strokeWidth={active ? 2.5 : 2} />
                </span>
                <span className={`text-[10px] font-medium leading-none tracking-wide ${active ? 'font-semibold' : ''}`}>
                  {tab.label}
                </span>
                {active && (
                  <span className="mt-0.5 h-0.5 w-6 rounded-full bg-primary" aria-hidden="true" />
                )}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default BottomTabNav;
